import React from 'react';
import styled from 'styled-components';
import numeral from 'numeral';
import ImageFadeIn from 'react-image-fade-in';
import { Body, Subhead, Caption1 } from '../../../../../components/Typography';

const ImageInner = styled.div`
  position: relative;
  display: inline-block;
  margin: 0 auto;
`;
const ImageCaptions = styled(Caption1)`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%) translateY(calc(50% - 8px));
  background-color: ${(props) => props.theme.primaryColor};
  color: ${(props) => props.theme.specificFeaturedColor || '#fff'};
  padding: 2px 4px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 300;
  text-align: center;
  z-index: 1;
`;

const Wrapper = styled.div`
  display: grid;
  grid-template-rows: 140px;
  grid-template-columns: ${(props) =>
    props.theme.productPreviewAlignImage === 'left'
      ? '140px 1fr'
      : '1fr 140px'};
  background: white;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.3);
  cursor: ${(props) => (props.isAvailable ? 'pointer' : 'default')};

  &:hover #MenuA-InfoSectionDescription {
    color: ${(props) =>
      props.isAvailable
        ? props.theme.darkGray
        : props.theme.unavailableProductColor};
  }
`;

const ImageWrapper = styled.div`
  order: ${(props) =>
    props.theme.productPreviewAlignImage === 'left' ? 0 : 2};
  padding: ${(props) =>
    props.theme.productPreviewImageShape === 'circle' ? '6px' : '0'};
  position: relative;
`;

const Image = styled(ImageFadeIn)`
  height: 100%;
  object-fit: cover;
  border-radius: ${(props) =>
    props.theme.productPreviewImageShape === 'circle' ? '50%' : 0};
  filter: ${(props) => (props.isAvailable ? null : 'grayscale(0.9)')};
`;

const InfoSection = styled.div`
  display: grid;
  padding: 14px;
  align-content: space-between;
`;

const Name = styled(Body)`
  text-transform: capitalize;
  color: ${(props) =>
    props.isAvailable ? 'inherit' : props.theme.unavailableProductColor};
`;

const Description = styled(Caption1)`
  color: ${(props) =>
    props.isAvailable
      ? props.theme.secondaryColor
      : props.theme.unavailableProductColor};

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-height: 20px; /* fallback */
  max-height: 60px; /* fallback */
  -webkit-line-clamp: 3; /* number of lines to show */
  -webkit-box-orient: vertical;
`;

const CalPriceRow = styled.div`
  display: flex;
  justify-content: ${(props) => (props.cals ? 'space-between' : 'flex-end')};
  align-self: flex-end;
`;

const Calories = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #000000;
`;

const Price = styled(Subhead)`
  color: ${(props) => {
    return props.isAvailable ? 'inherit' : props.theme.unavailableProductColor;
  }};
  display: ${(props) =>
    props.theme.productPreviewShowPrice ? 'inherit' : 'none'};
`;
const ProductPreview = ({ product, handleProductPreviewClick }) => {
  return (
    <Wrapper
      onClick={() =>
        product.is_product_available
          ? handleProductPreviewClick(product.product_id, product)
          : null
      }
      isAvailable={product.is_product_available}
    >
      <ImageWrapper>
        <ImageInner>
          <Image
            isAvailable={product.is_product_available}
            src={product.image_url}
          />
          {product.is_featured && <ImageCaptions>Featured</ImageCaptions>}
        </ImageInner>
      </ImageWrapper>
      <InfoSection>
        <Name
          id='MenuA-InfoSectionName'
          isAvailable={product.is_product_available}
        >
          {product.name}
        </Name>
        {product.user_description && (
          <Description
            id='MenuA-InfoSectionDescription'
            isAvailable={product.is_product_available}
          >
            {product.user_description}
          </Description>
        )}
        <CalPriceRow cals={product.calories != null}>
          {product.calories != null && (
            <Calories>{product.calories} CALS</Calories>
          )}
          <Price
            id='MenuA-InfoSectionPrice'
            isAvailable={product.is_product_available}
          >
            {numeral(
              product.prices.find((price) => price.is_default).price
            ).format('$0.00')}
          </Price>
        </CalPriceRow>
      </InfoSection>
    </Wrapper>
  );
};

export default ProductPreview;
